import { Components, Theme } from '@mui/material/styles';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

export const flowBreadCrumbs: Components<Theme>['MuiBreadcrumbs'] = {
  defaultProps: {
    separator: <span aria-hidden="true">{'/'}</span>,
    maxItems: 99,
    'aria-label': 'breadcrumb',
  },
  styleOverrides: {
    root: () => ({
      // do not wrap and show scrollbar
      overflowX: 'auto',
      // force scrollbar to start at the end
      display: 'flex',
      flexDirection: 'row-reverse',
    }),
    ol: {
      // breadcrumbs next to each other
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      flexGrow: '1',
      padding: '4px 0',
    },
    li: ({ theme }) => ({
      '.MuiLink-root, .MuiTypography-root': {
        ...theme.typography.list,
        display: 'inline-flex',
        position: 'relative',
        borderRadius: '4px',
        color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os200 : theme.palette.onSurface.os700,
        // extra space around link for the focus border
        margin: '2px',
        padding: '0 2px',
        ...getFocusRingStyle(theme, false, '0px'),
        '&.Mui-focusVisible': {
          outline: 'none',
        },
      },
      '.MuiLink-root:hover': {
        color: theme.palette.text.primary,
        textDecoration: 'underline',
        textDecorationThickness: '1px',
        textUnderlineOffset: '2px',
      },
      // last element (active)
      '&:last-of-type': {
        '.MuiLink-root, .MuiTypography-root': {
          fontWeight: '700',
          color: theme.palette.text.primary,
        },
      },
    }),
    // element between clickable and non-clickable breadcrumbs '/'
    separator: ({ theme }) => ({
      ...theme.typography.list,
      color: theme.palette.mode === 'dark' ? theme.palette.onSurface.os200 : theme.palette.onSurface.os700,
      margin: '0 4px',
    }),
  },
};
